<template>
  <icon-base
    :title="title"
    :name="name"
    :viewbox="viewBox">
    



<g>
	<path d="M9.325,17.916c-0.117,0-0.235-0.012-0.352-0.035c-0.472-0.094-0.879-0.365-1.146-0.764l-2.44-3.462
		c-0.238-0.338-0.157-0.807,0.181-1.045C5.695,12.52,5.844,12.473,6,12.473c0.244,0,0.473,0.119,0.614,0.318l2.45,3.477
		c0.054,0.081,0.12,0.126,0.201,0.142c0.02,0.004,0.04,0.006,0.06,0.006c0.058,0,0.115-0.018,0.164-0.051
		c0.028-0.019,0.052-0.042,0.072-0.068l7.852-9.935C17.555,6.182,17.769,6.078,18,6.078c0.168,0,0.333,0.057,0.464,0.161
		c0.157,0.124,0.257,0.302,0.28,0.501c0.023,0.199-0.032,0.395-0.156,0.552l-7.843,9.923c-0.113,0.149-0.257,0.284-0.423,0.396
		C10.025,17.811,9.68,17.916,9.325,17.916z"/>
	<path d="M12,23.999c-6.617,0-12-5.383-12-12c0-6.617,5.383-12,12-12c6.617,0,12,5.383,12,12C24,18.616,18.617,23.999,12,23.999z
		 M12,1.499c-5.79,0-10.5,4.71-10.5,10.5c0,5.79,4.71,10.5,10.5,10.5c5.79,0,10.5-4.71,10.5-10.5C22.5,6.209,17.79,1.499,12,1.499z"
		/>
</g>


  </icon-base>
</template>

<script>
import IconBase from '../IconBase';

export default {
  components: {
    IconBase,
  },
  props: {
    title: {
      type: String,
      required: false,
      default: 'check-circle-1',
    },
    name: {
      type: String,
      required: false,
      default: 'CheckCircle1',
    },
    viewBox: {
      type: String,
      required: false,
      default: '0 0 24 24',
    },
  },
};
</script>

<style scoped>
  
</style>